export const DATE_MASK = { mask: 'dd.mm.yyyy', replacement: { d: /\d/, m: /\d/, y: /\d/ } };
export const PROGRAM_NUMBER_MASK = { mask: 'ddd', replacement: { d: /\d/ } };
export const TIME_MASK = {
  mask: 'hH:zz xb', replacement: { h: /[0-1]/, H: /[0-9]/, z: /\d/,  x: /[APap]/, b: /[Mm]/ },
};
